var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, ModelSync, Prop, Watch } from 'vue-property-decorator';
import { BOverlay, BFormRadioGroup, BFormRadio } from 'bootstrap-vue';
import axios from 'axios';
import debounce from 'lodash/debounce';
let FixingOptions = class FixingOptions extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.maxSqmmForHanger = 205000;
        this.stringPrice = '0.00';
        this.hangerPrice = '0.00';
        this.debouncedUpdateStringPrice = debounce(this.updateStringPrice, 350);
    }
    get diffInPrice() {
        let diff = parseFloat(this.stringPrice) - parseFloat(this.hangerPrice);
        let str = diff > 0 ? '+' : '';
        return `${str}£${diff.toFixed(2)}`;
    }
    get isHangerDisabled() {
        return (this.rebateSize.width * this.rebateSize.length) > this.maxSqmmForHanger;
    }
    updateStringPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            // Get the d-rings price
            let { data } = yield axios
                .get('/api/pricing/frame/fixings', {
                params: {
                    width: this.rebateSize.width,
                    length: this.rebateSize.length,
                    valueGroupID: this.groupId
                }
            });
            this.stringPrice = data.unit_price;
            if (this.isHangerDisabled) {
                this.$emit('change', 'string');
            }
            this.loading = false;
        });
    }
    mounted() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            let { data } = yield axios
                .get('/api/pricing/units/price', { params: { sku: `FX-46`, valueGroupID: this.groupId } });
            this.hangerPrice = data.unit_price;
            this.updateStringPrice();
        });
    }
};
__decorate([
    ModelSync('fixing', 'change', { type: String })
], FixingOptions.prototype, "selectedFixing", void 0);
__decorate([
    Prop(Number)
], FixingOptions.prototype, "groupId", void 0);
__decorate([
    Prop(Object)
], FixingOptions.prototype, "rebateSize", void 0);
__decorate([
    Watch('rebateSize', { deep: true })
], FixingOptions.prototype, "debouncedUpdateStringPrice", void 0);
FixingOptions = __decorate([
    Component({
        components: {
            BOverlay, BFormRadioGroup, BFormRadio
        }
    })
], FixingOptions);
export default FixingOptions;
